var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12C9.87206 12 7.79905 12.8195 6.07987 14.3404C4.36069 15.8613 3.08417 18.005 2.43435 20.4624C2.36426 20.7275 2.4028 21.0172 2.53807 21.242C2.67334 21.467 2.88906 21.6 3.11859 21.6H20.8814C21.111 21.6 21.3267 21.467 21.462 21.242C21.5973 21.0172 21.6358 20.7275 21.5657 20.4624C20.9159 18.005 19.6393 15.8613 17.9202 14.3404C16.201 12.8195 14.128 12 12 12Z",
    fill: "#3D7DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.40002C9.01764 2.40002 6.59998 4.81769 6.59998 7.80004C6.59998 10.7824 9.01764 13.2 12 13.2C14.9823 13.2 17.4 10.7824 17.4 7.80004C17.4 4.81769 14.9823 2.40002 12 2.40002Z",
    fill: "#FFCCA8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85969 6.13475C7.56228 3.96789 9.59709 2.40002 11.9996 2.40002C14.6321 2.40002 16.8238 4.28244 17.3042 6.77444C17.3363 6.94102 17.2926 7.11326 17.1851 7.24444C17.0774 7.37563 16.9172 7.45216 16.7475 7.45329L16.7113 7.45342C15.3551 7.45342 14.1178 6.94179 13.1829 6.10221C12.2479 6.94181 11.0106 7.45345 9.65434 7.45345C8.74099 7.45345 7.88019 7.22117 7.12951 6.81203C6.88834 6.68058 6.77498 6.39602 6.85969 6.13475Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMember);
export default __webpack_public_path__ + "static/media/member.290eff86e2eb8b7b9c820bb68b48873e.svg";
export { ForwardRef as ReactComponent };